import React from 'react';
import { useAppVariableComponent } from './useAppVariableComponent';
import { Box, Checkbox, FormControlLabel, Grid } from '@mui/material';
import AppFormSelectWrapper from '../../../../components/designe/app-form-select-wrapper';
import { useTranslation } from 'react-i18next';
import AppButton from '../../../../components/designe/app-button/AppButton';
import { useStyles } from './AddAppVariable.styles';
import theme from '../../../../styles/theme';
import AppFormTextField from '../../../../components/designe/app-form-text-field';
import { IAppVariable } from '../../../../types/interfaces/app-variable';
import { AppVariableType } from '../../../../shared/constants';

interface IAddAppVariableProps {
  appVariable: IAppVariable;
  onClose: () => void;
}

export default function AddAppVariable(props: IAddAppVariableProps) {
  const { appVariable, onClose } = props;
  const { t } = useTranslation();
  const { formik, isLoading } = useAppVariableComponent(onClose, appVariable);
  const { classes } = useStyles(theme);

  const appVariableTypeOptions = Object.values(AppVariableType)?.map(
    (option) => ({
      id: option,
      name: option,
    }),
  );

  return (
    <Box>
      <form onSubmit={formik.handleSubmit}>
        <Grid container spacing={1}>
          <Grid item sm={12}>
            <AppFormTextField
              label={t('common.key')}
              fullWidth
              name="key"
              formik={formik}
            />
          </Grid>
          <Grid item sm={12}>
            <AppFormTextField
              label={t('common.value')}
              fullWidth
              name="value"
              formik={formik}
            />
          </Grid>
        </Grid>
        <Grid item sm={12}>
          <AppFormSelectWrapper
            label={t('common.type')}
            name="type"
            options={appVariableTypeOptions}
            defaultValue={appVariableTypeOptions?.find(
              (t) => t.id === formik.values.type,
            )}
            onChange={(e) => formik.setFieldValue('type', e.target.value.id)}
            formik={formik}></AppFormSelectWrapper>
        </Grid>
        <Grid item sm={12}>
          <FormControlLabel
            control={
              <Checkbox
                name="isPrivate"
                checked={formik.values.isPrivate}
                onChange={(e) =>
                  formik.setFieldValue('isPrivate', e.target.checked)
                }></Checkbox>
            }
            label={t('common.private')}
          />
        </Grid>
        <Box className={classes.addAppVariableButtonWrapper}>
          <AppButton variant="outlined" onClick={() => onClose()}>
            {t('common.cancel')}
          </AppButton>
          <AppButton type="submit" loader={isLoading}>
            {appVariable ? t('common.update') : t('common.create')}
          </AppButton>
        </Box>
      </form>
    </Box>
  );
}
